import React from "react";
import "./AboveFooter.css";

const items = [
  {
    icon: "◉",
    label: "Inhaber",
    value: "Egzon Gjocaj",
    href: null,
  },
  {
    icon: "✉",
    label: "E-Mail",
    value: "info@gala-egbau.de",
    href: "mailto:info@gala-egbau.de",
  },
  {
    icon: "✆",
    label: "Telefon",
    value: "+49 151 5562 9922",
    href: "tel:+4915155629922",
  },
  {
    icon: "◈",
    label: "Adresse",
    value: "Lister Damm 35, 30163 Hannover",
    href: "https://maps.google.com/?q=Lister+Damm+35+30163+Hannover",
  },
];

export default function AboveFooter() {
  return (
    <div className="af-root">
      {/* decorative top line */}
      <div className="af-topline" aria-hidden />

      <div className="af-inner">
        {items.map((item, i) => (
          <React.Fragment key={i}>
            <div className="af-item">
              <span className="af-icon" aria-hidden>{item.icon}</span>
              <div className="af-text">
                <span className="af-label">{item.label}</span>
                {item.href ? (
                  <a href={item.href} className="af-value" target={item.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                    {item.value}
                  </a>
                ) : (
                  <span className="af-value">{item.value}</span>
                )}
              </div>
            </div>
            {i < items.length - 1 && <div className="af-divider" aria-hidden />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}